var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Subject, BehaviorSubject } from 'rxjs';
import { ApiService } from '@api/service';
import { tap } from 'rxjs/operators';
var AppService = /** @class */ (function () {
    function AppService(api) {
        this.api = api;
        this.defaultState = null;
        this.state = this.defaultState;
        this.appSubject = new BehaviorSubject(this.state);
    }
    AppService.prototype.setState = function (newState) {
        this.state = __assign({}, this.state, newState);
        this.appSubject.next(this.state);
    };
    AppService.prototype.getState = function () {
        return this.appSubject;
    };
    AppService.prototype.getWhoAmI = function (forceFetch) {
        var _this = this;
        if (forceFetch === void 0) { forceFetch = false; }
        this.api.user
            .whoAmI()
            .pipe(tap(function (whoAmI) { return _this.setState(whoAmI); }))
            .subscribe();
    };
    return AppService;
}());
export { AppService };
